import { useStore } from '../../../store';

export const useLegalEntitiesStore = () => {
    const { legalEntities } = useStore();
    return legalEntities;
};
